import Vue from "vue";
import Qs from "qs";
import VueRouter from "vue-router";
import * as echarts from "echarts";
import { buildMacarons } from "./utils/macarons";

window.Vue = Vue;
Vue.use(VueRouter);
// 初次注册（亮色默认）；data-theme 应用后会在下方再次按当前模式注册
echarts.registerTheme("macarons", buildMacarons());

import App from "./App.vue";
import router from "./router/router";
import store from "./store/store";
import api from "./http/index";
import menuUtil from "./utils/index";
import "./directive/directives";
import url from "./interface/url";
import toolUtil from "./utils/toolUtil";
import timeUtil from "./utils/timeUtil";
import "./assets/icon/iconfont.css";
import VueScroll from "vuescroll";
import "vuescroll/dist/vuescroll.css";
import md5 from "js-md5";
import permission from "./directive/permission";
import cloud from "./utils/cloud";
import message from "./utils/message";
import method from "./interface/method";
import i18n from "./utils/i18n";
import Clipboard from "v-clipboard";
import tools from "./utils/tools";
import eventBus from "./utils/eventBus";
import "@/utils/default-passive-events.js";
//  富文本编辑器
import { ElementTiptapPlugin } from "element-tiptap";
// 引入 ElementUI
import ElementUI from "element-ui";
// 引入 ElementUI 样式
import "element-ui/lib/theme-chalk/index.css";
// VTM 设计令牌 + Element 品牌皮肤（须在 theme-chalk 之后加载）
import "./assets/scss/tokens.scss";
import "./assets/scss/element-skin.scss";
import "./assets/scss/components.scss";
import { initTheme } from "./utils/theme";
// Element 语言绑定到 vue-i18n（随 setLang 切换，修复组件内置文案不随语言变化的问题）
import ElementLocale from "element-ui/lib/locale";
// 引入 import element-tiptap 样式
import "element-tiptap/lib/index.css";
import "animate.css";
// 安装 element-tiptap 插件
Vue.use(ElementTiptapPlugin, {
  lang: "en" // 设置语言为英文
});
// 安装 ElementUI，并把其内置文案交给 vue-i18n 处理（跟随当前语言）
Vue.use(ElementUI);
ElementLocale.i18n((key, value) => i18n.t(key, value));
Vue.use(permission);

Vue.config.productionTip = false;
// 应用启动即恢复主题（亮/暗），避免闪烁
initTheme();
// 主题应用后，按当前亮/暗模式重新注册图表主题，使图表随模式着色（暗色不再白底）
echarts.registerTheme("macarons", buildMacarons());
Vue.use(store);
Vue.use(VueScroll);
Vue.use(Clipboard);
Vue.prototype.$vuescrollConfig = {
  bar: {
    size: "4px",
    hoverStyle: true, // 移入鼠标就显示滚动条
    onlyShowBarOnScroll: false, // 是否只有滚动的时候才显示滚动条
    background: "hsla(220,4%,58%,.3)"
  }
};
import { VueJsonp } from "vue-jsonp";
Vue.use(VueJsonp);

Vue.prototype.$method = method;

Vue.use(api);
Vue.prototype.$qs = Qs;
Vue.prototype.$url = url;
Vue.prototype.$toolUtil = toolUtil;
Vue.prototype.$timeUtil = timeUtil;
Vue.prototype.$md5 = md5;
Vue.prototype.$cloud = cloud;
Vue.prototype.$message = message;
Vue.prototype.$tools = tools;
Vue.prototype.$eventBus = eventBus;
Vue.prototype.$currency = val => {
  if (val === null || val === undefined || val === "") return "—";
  const num = Number(val);
  if (isNaN(num)) return val;
  return "$" + num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
Vue.prototype.$formatDate = timeUtil.formatTo12Hour;

router.beforeEach((to, _from, next) => {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else if (to.name) {
    document.title = to.name;
  }
  if (to.path === "/login") {
    next();
  } else {
    if (store.state.token) {
      if (to.path === "/") {
        router.push("/main");
      } else {
        menuUtil.initMenu(router, store);
        next();
      }
    } else {
      router.push("/login");
    }
  }
});

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount("#app");
